import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=71e9da7e&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=71e9da7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e9da7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e9da7e')) {
      api.createRecord('71e9da7e', component.options)
    } else {
      api.reload('71e9da7e', component.options)
    }
    module.hot.accept("./GameCard.vue?vue&type=template&id=71e9da7e&scoped=true", function () {
      api.rerender('71e9da7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/GameCard.vue"
export default component.exports